<template>
  <header class="top-0 bg-white dark:bg-darkblue-900 px-4 lg:px-10 flex-none">
    <div class="flex responsive-spacing-y space-x-2 items-center">
      <div v-if="!content.url"
        class="group flex-none h-11 w-11 bg-secondary-50 dark:bg-darkblue flex items-center justify-center rounded-full">
        <BaseIcon :name="content.icon" class="text-secondary dark:text-darkblue-200" />
      </div>
      <div v-else class="group flex-none">
        <router-link :to="{ name: content.url }">
          <base-button-icon name="arrowleft" size="lg" mode="primary-phantom" />
        </router-link>
      </div>
      <div class="relative w-full">
        <ul v-if="content.breadcrumb"
          class="breadcrumbs absolute -top-4 text-sm left-0 flex items-top space-x-2 truncate">
          <li v-for="(item, idx) in content.breadcrumb" :key="idx" class="">
            <router-link :to="{ name: item.path }">{{ item.name }}</router-link>
          </li>
        </ul>
        <h2 class="font-medium dark:text-white">{{ content.title }}</h2>
      </div>
      <div v-if="hasNav" ref="nav" v-outside:click="{ exclude: ['nav'], handler: closeNav }"
        class="flex-none relative ml-auto lg:hidden">
      </div>
      <div v-if="(role === 7 || role === 8 || role === 3) && !isLower1024" class="flex w-full">
        <base-button mode='primary-phantom' size="xs" :text="$t('app.apply_all')" :disabled="disableSelect"
          @click="applyAllFilter" class="mr-2 w-56 whitespace-nowrap" />
        <base-el-select v-model="selectedClient" :options="finalDataSelect" @change="changeClient" name="clientsselect" size="small"
          class="mr-2 w-full" :disabled="disableSelect" filterable />
      </div>
      <div class="test">
        <base-button v-if="hasDashboardFinanciero" mode='primary-phantom' size="xs" :text="$t('financial_dashboard.header')" :disabled="disableSelect"
        @click="goFinancialDashboard" class="mr-2 w-56 whitespace-nowrap " />
      </div>
    </div>
    <div v-if="(role === 7 || role === 8 || role === 3) && isLower1024" class="flex mb-4 w-full">
      <base-button mode='primary-phantom' size="xs" :text="$t('app.apply')" :disabled="disableSelect"
        @click="applyAllFilter" class="mr-2 w-56 whitespace-nowrap" />
      <base-el-select v-model="selectedClient" :options="finalDataSelect" @change="changeClient" name="clientsselect" size="small"
        class="mr-2 w-full" :disabled="disableSelect" filterable />
    </div>
    <div v-if="hasNav" class="h-8 flex items-center mb-4 lg:hidden">
      <h3 class="font-bold">{{ $t('app.general_information') }}</h3>
    </div>
  </header>
</template>

<script>
import { i18n } from '@/i18n'
// import DropDownNav from '@/components/DropDownNav.vue'
import { getClients } from '@/services/clients/getClients'
import { bus } from '@/main'

export default {
  name: 'base-header',
  props: {
    content: {
      type: [Array, Object],
      required: true
    },
    disableSelect: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // DropDownNav
  },
  async mounted () {
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.selectedClient = this.$store.getters['dashboard/getSelectedClient']
      await this.getClients()
      // this.applyAllFilter(true)
    }
  },
  data: function () {
    return {
      nav: false,
      dataSelect: [],
      selectedClient: -1,
    }
  },
  computed: {
    hasNav: function () {
      return this.content.nav
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    emptyClient: function () {
      return { value: -1, label: `-- ${i18n.t('app.disabled')} --` }
    },
    allClients: function () {
      return { value: 0, label: i18n.t('clients.all_clients') } 
    },
    finalDataSelect: function () {
      const data = [this.emptyClient]
      if (this.role !== 7 && this.role !== 8) {
        data.push(this.allClients)
      }
      data.push(...this.dataSelect)
      return data
    },
    id () {
      return this.$route.params.id
    },
    hasDashboardFinanciero () {
      return this.$store.getters['auth/hasDashboardFinanciero']
    },
  },
  methods: {
    applyAllFilter (silent = false) {
      this.$store.dispatch('app/applyAllFilter', silent)
      // Refresca nav y alertas
      bus.$emit('changeIt', 'changed menu')
      this.$store.dispatch('app/getAnnouncementsList')
      if (silent !== true) {
        this.doFeedback(i18n.t('feedback.success.client_filter_applied_msg'), 'success')
      }
    },
    goFinancialDashboard () {
      this.$store.dispatch('financialdashboard/resetAll')
      this.$router.push({ name: 'financialdashboard', params: { id: this.id } })
    },
    getClients: async function () {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      } else {
        this.dataSelect = []
        dataClients.Clientes.forEach(element => {
          this.dataSelect.push({ value: element.idCliente, label: element.Nombre })
        })
        this.dataSelect.sort((a, b) => a.Nombre - b.Nombre)
      }
    },
    toggleNav: function () {
      this.nav = !this.nav
    },
    closeNav: function () {
      this.nav = false
    },
    changeClient (idClient) {
      this.selectedClient = idClient
      this.$store.dispatch('dashboard/setSelectedClient', idClient)
      const clientName = this.finalDataSelect.filter(x => x.value === idClient)[0].label
      this.$store.dispatch('dashboard/setSelectedClientName', clientName)
      this.$emit('onChangeClient')
    }
  }
}
</script>
<style lang="scss" scoped>
.breadcrumbs {
  li {
    @apply text-secondary dark:text-white font-bold;
    &:not(:last-child) {
      @apply text-secondary-500 dark:text-white font-normal;
      &:after {
        content:'→';
        margin-left:0.25rem;
      }
    }
  }
}
</style>
